import { AccessRequirement } from "./permissions";
import { PERMISSIONS, ROLES } from "./permissions";
import {
  ROLES_COMUNICADOS,
  ROLES_CADASTROS,
  ROLES_CONFIGURACOES,
  ROLES_FINANCEIRO,
  ROLES_LOJA_OPERACIONAL,
  ROLES_ORCAMENTO,
  ROLES_PAINEL_VIEW,
  ROLES_RESULTADOS,
} from "./panelRoleGroups";

/** Requisito padrão para itens do painel sem config explícita. */
export const DEFAULT_ROUTE_ACCESS: AccessRequirement = {
  roles: ROLES_PAINEL_VIEW,
  permissions: [PERMISSIONS.PERMISSION_VIEW],
};

/**
 * Requisitos de acesso por `key` das rotas em routes.tsx.
 * Alinhado com preHandlers do backend. Super admin ignora estas regras.
 */
export const ROUTE_ACCESS: Record<string, AccessRequirement> = {
  estatisticasEvento: {
    roles: ROLES_PAINEL_VIEW,
    permissions: [PERMISSIONS.PERMISSION_VIEW],
  },
  inscricoes: {
    roles: ROLES_PAINEL_VIEW,
    permissions: [PERMISSIONS.PERMISSION_VIEW],
  },
  eventos: {
    roles: ROLES_PAINEL_VIEW,
    permissions: [PERMISSIONS.PERMISSION_VIEW],
  },
  "pedidos-acesso": { roles: ROLES_LOJA_OPERACIONAL },
  resultado: {
    roles: ROLES_RESULTADOS,
    permissions: [PERMISSIONS.PERMISSION_VIEW],
  },

  orcamento: {
    roles: ROLES_ORCAMENTO,
    permissions: [PERMISSIONS.PERMISSION_VIEW],
  },
  "orcamento-solicitacoes": {
    roles: ROLES_ORCAMENTO,
    permissions: [PERMISSIONS.PERMISSION_VIEW],
  },
  "orcamento-servicos": {
    roles: ROLES_ORCAMENTO,
    permissions: [PERMISSIONS.PERMISSION_VIEW],
  },

  comunicados: { roles: ROLES_COMUNICADOS },
  messenger: {
    roles: ROLES_PAINEL_VIEW,
    permissions: [PERMISSIONS.PERMISSION_VIEW],
  },

  financeiro: { roles: ROLES_FINANCEIRO },
  "lancamentos-vendas": { roles: ROLES_FINANCEIRO },
  cupons: { roles: ROLES_FINANCEIRO },
  "financeiro-eventos": { roles: ROLES_FINANCEIRO },
  extrato: { roles: ROLES_FINANCEIRO },
  "extrato-financeiro": { roles: ROLES_FINANCEIRO },
  taxas: { roles: ROLES_FINANCEIRO },
  "contas-pagar": { roles: ROLES_FINANCEIRO },
  "contas-receber": { roles: ROLES_FINANCEIRO },
  "dre-gerencial": { roles: ROLES_FINANCEIRO },
  "contas-financeiras": { roles: ROLES_FINANCEIRO },
  "logs-cobrancas": { roles: ROLES_FINANCEIRO },

  cadastros: { roles: ROLES_CADASTROS },
  "cadastros-eventos": { roles: ROLES_CADASTROS },
  atletas: { roles: ROLES_CADASTROS },
  modalidades: { roles: ROLES_CADASTROS },
  organizadores: { roles: ROLES_CADASTROS },
  usuarios: { roles: ROLES_CADASTROS },
  patrocinadores: { roles: ROLES_CADASTROS },

  "loja-virtual": { roles: ROLES_LOJA_OPERACIONAL },
  produtos: { roles: ROLES_LOJA_OPERACIONAL },
  pedidos: { roles: ROLES_LOJA_OPERACIONAL },
  "loja-estoque": { roles: ROLES_LOJA_OPERACIONAL },
  avaliacoes: { roles: ROLES_LOJA_OPERACIONAL },
  atributos: { roles: ROLES_LOJA_OPERACIONAL },
  categorias: { roles: ROLES_LOJA_OPERACIONAL },
  marcas: { roles: ROLES_LOJA_OPERACIONAL },
  "loja-cupons": { roles: ROLES_LOJA_OPERACIONAL },

  configuracoes: { roles: ROLES_CONFIGURACOES },
  "melhor-envio": { roles: ROLES_CONFIGURACOES },
  "controle-acesso": { roles: [ROLES.ROLE_ADMIN] },
};

/** Rotas extras registradas em App.tsx (fora de routes.tsx). */
export const EXTRA_ROUTE_ACCESS: Record<string, AccessRequirement> = {
  "/loja/produtos/create": {
    roles: ROLES_LOJA_OPERACIONAL,
    permissions: [PERMISSIONS.PERMISSION_CREATE],
  },
  "/loja/produtos/editar": {
    roles: ROLES_LOJA_OPERACIONAL,
    permissions: [PERMISSIONS.PERMISSION_UPDATE],
  },
  "/loja/pedidos": { roles: ROLES_LOJA_OPERACIONAL },
  "/loja/pagamentos": { roles: ROLES_FINANCEIRO },
  "/layouts/pages/cadastros/eventos": { roles: ROLES_CADASTROS },
};
